<template>
  <div style="width:1300px;margin:30px auto 0;">
    <div class="breadcrumb"><a href="/">首页</a>&nbsp;&nbsp;>&nbsp;&nbsp;{{this.columnName}}</div>
    <div class="details" style="padding-top:30px;">
      <!-- <h1>{{listdetails.news_art_title}}</h1>
      <h3>
        来源：{{listdetails.news_art_source}}&nbsp;&nbsp;&nbsp;&nbsp;发布时间：{{listdetails.news_art_time}}&nbsp;&nbsp;&nbsp;&nbsp;
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            分享<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">微信</el-dropdown-item>
            <el-dropdown-item>QQ</el-dropdown-item>
            <el-dropdown-item>QQ空间</el-dropdown-item>
            <el-dropdown-item>新浪微博</el-dropdown-item>
            <el-dropdown-item>腾讯微博</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </h3> -->
      <div class="ns" v-html="listdetails.news_art_content"></div>
      <!-- <el-dialog
        title="分享到微信朋友圈"
        :visible.sync="qrCodeDialogVisible"
        width="280px"
        @opened="qrCodeCreate"
        :before-close="qrCodeHandleClose">
        <div>
          <div id="qrCode" ref="qrCode"></div>
        </div>
        <span slot="footer" class="dialog-footer">
          打开微信，点击底部的“发现”，<br/>
          使用“扫一扫”即可将网页分享至朋友圈。
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import "@/assets/css/style.css";
import {imgPath,cityId,permissionsId,keywords,description,metatitle,SiteName,SiteDomain} from "@/api/api"
export default {
  name: "detail",
  data() {
    return {
      listdetails: [],
      imgPath,
      cityId,
      permissionsId,
      columnName:'',
      qrCodeDialogVisible: false,
    };
  },
  metaInfo(){
    return{
      title:this.columnName + "_" + metatitle,
      meta:[
        {name:'Keywords',content:this.listdetails.news_art_title},
        {name:'Author',content:this.listdetails.news_art_source},
        {name:"Description",content:this.listdetails.news_art_title},
        {name:"SiteName",content:SiteName},
        {name:"SiteDomain",content:SiteDomain},
        {name:"SiteIDCode",content:"辽ICP备16006427号-2"},
        {name:"ColumnName",content:this.columnName},
        {name:"ColumnDescription",content:this.columnName},
        {name:"ColumnKeywords",content:this.columnName},
        {name:"ColumnType",content:this.columnName},
        {name:"ArticleTitle",content:this.listdetails.news_art_title},
        {name:"PubDate",content:this.listdetails.news_art_time},
        {name:"ContentSource",content:this.listdetails.news_art_source},
        {name:"Image",content:imgPath + this.listdetails.news_img_path},
        {name:"Url",content:window.location.href},
      ]
    }
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path != from.path){
        this.path = to.path;
        this.httpPost();//重新加载数据
      }
    }
  },
  created() {
    this.httpPost();
    // this.qrCodeCreate();
    // let routes = window.location.href; // 获取当前打开过的页面路由数组
    // this.route = routes;
    // this.route = 'http://120.201.230.21:10001/cs/#/'
  },
  methods: {
    httpPost() {
      const _this = this;
      this.$http({
        headers:"application/json; charset=utf-8",
        url: "/api/News/GetNewsList",
        data:{
          "city_id":cityId,
          "permissions_id":permissionsId,
          "column_id":_this.$route.params.columnId
        },
        success(res){
          _this.listdetails = res.extend.news;
          _this.columnName = res.extend.columnName;
        }
      })
    },
    handleCommand(command) {
      if(command == 1){
        this.qrCodeDialogVisible = true;
      }
    },
    // qrCodeHandleClose() {
    //   this.qrCodeDialogVisible = false;
    //   this.qrCode = '';
    //   document.getElementById('qrCode').innerHTML = '';
    // },
      //创建二维码
    // qrcode() {
    //   let _this = this;
    //   this.qrCode = new QRCode('qrCode', {
    //     text: _this.route,
    //     width: 240,
    //     height: 240
    //   })
    // },
    // qrCodeCreate(){
    //   let url = 'www.baidu.com'
    //   this.$nextTick(() => {
    //     this.qrcode(url);
    //   })
    // },
    //二维码显示
    // qrCodeOpen(val) {
    //   this.qrCodeDialogVisible = true;
    // }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/detail/details.vue